import {createContext} from 'react';

import {IBreadcrumbItem} from 'components/breadcrumbs';

export interface IBreadcrumbsContextState {
    breadcrumbs: IBreadcrumbItem[] | undefined;
}

export const BreadcrumbsContext = createContext<IBreadcrumbsContextState>({
    breadcrumbs: undefined,
});
